export class Address {
    public id?: string;
    public address: string;
    public goo_place_id: string;
    public lat: number;
    public lng: number;
    public address_line_1?: string;
    public address_line_2?: string;
    public street?: string;
    public street_two?: string;
    public city?: string;
    public zipcode?: string;
    public postal_code?: string;
    public state?: string;
    public country?: string;
    public utc_offset?: number;
    public googleName?: string;
}